import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Imagine being tasked with estimating the quality of two different sounds. Provided below are the average sound pressure levels and the 1/3rd octave spectra of both sounds.",
  theory: theory,
  layout: {
    type: "custom020600",
    options: {
      data: {
        left: {
          imageUrl: `${config.ASSETS_URL}/02/06/principle/chart-1.svg`,
          audioUrl: `${config.ASSETS_URL}/02/06/principle/electric-motor.wav`,
        },
        right: {
          imageUrl: `${config.ASSETS_URL}/02/06/principle/chart-2.svg`,
          audioUrl: `${config.ASSETS_URL}/02/06/principle/classical-music.wav`,
        },
      },
    },
  },
};

export default principle;
